import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './RevenuesComponent.metadata.json5';

import styles from '../ITProfessional.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RevenuesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RevenuesComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getTotalGrossRevenue = () => {
        // eslint-disable-next-line no-nested-ternary
        const grossRevCan = _.isUndefined(modelVM.value.perOfLas12MonGroRev2) ? 0 : 
        (modelVM.value.perOfLas12MonGroRev2 === '' ? 0 : modelVM.value.perOfLas12MonGroRev2)
        // eslint-disable-next-line no-nested-ternary
        const grossRevUSA = _.isUndefined(modelVM.value.perOfLas12MonGroRev3) ? 0 : 
        (modelVM.value.perOfLas12MonGroRev3 === '' ? 0 : modelVM.value.perOfLas12MonGroRev3)
        // eslint-disable-next-line no-nested-ternary
        const grossRevOth = _.isUndefined(modelVM.value.perOfLas12MonGroRev4) ? 0 : 
        (modelVM.value.perOfLas12MonGroRev4 === '' ? 0 : modelVM.value.perOfLas12MonGroRev4)

        return grossRevCan + grossRevUSA + grossRevOth;
    }

    const getEstGrossRevenue = () => {
        // eslint-disable-next-line no-nested-ternary
        const estGrossRevCan = _.isUndefined(modelVM.value.perOfEstGroRevDerFro7) ? 0 : 
        (modelVM.value.perOfEstGroRevDerFro7 === '' ? 0 : modelVM.value.perOfEstGroRevDerFro7)
        // eslint-disable-next-line no-nested-ternary
        const estGrossRevUSA = _.isUndefined(modelVM.value.perOfEstGroRevDerFro8) ? 0 : 
        (modelVM.value.perOfEstGroRevDerFro8 === '' ? 0 : modelVM.value.perOfEstGroRevDerFro8)
        // eslint-disable-next-line no-nested-ternary
        const estGrossRevOth = _.isUndefined(modelVM.value.perOfEstGroRevDerFro9) ? 0 : 
        (modelVM.value.perOfEstGroRevDerFro9 === '' ? 0 : modelVM.value.perOfEstGroRevDerFro9)

        return estGrossRevCan + estGrossRevUSA + estGrossRevOth;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totalGrossRevenue: {
            required: true,
            value: getTotalGrossRevenue()
        },
        estGrossRevenue: {
            required: true,
            value: getEstGrossRevenue()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenuesComponent.propTypes = wizardProps;
export default withRouter(RevenuesComponent);
